// Ionic & Angular Imports
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: "workHours"
})
export class WorkHoursPipe implements PipeTransform {
    transform(inputValue: string) : string {
        // Parse our input value into hours and minutes
        let parts : string[] = inputValue.split(":");
        let inHour :number = parseInt(parts[0]); let inMinutes : number = parseInt(parts[1]);

        // Convert hours to the correct integer
        let hour : number = inHour > 12 ? inHour - 12 : inHour; 
        if( hour == 0 ) hour = 12;  // Correct for midnight
    
        // Create a suffix based on the original hours 
        let suffix : string = inHour >= 12 ? "PM" : "AM";

        return hour.toString() + ":" + ("0" + inMinutes).slice(-2) + " " + suffix; 
    }
}


// WEBPACK FOOTER //
// ./src/pipes/workhours.pipe.ts